import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry && !orig.url.includes("/auth/") && !orig.url.includes("/portal/") && !orig.url.includes("/sub/") && !orig.url.includes("/public/")) {
      orig._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch (e) { /* fall through */ }
    }
    return Promise.reject(err);
  }
);

export function fmtErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || "Something went wrong";
}

export const money = (n) => new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(n || 0);
export const money0 = (n) => new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 }).format(n || 0);
export const fdate = (d) => (d ? new Date(d).toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fday = (d) => (d ? new Date(d).toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" }) : "—");
export const fdayLong = (d) => (d ? new Date(d).toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long" }) : "—");
export const ftime = (d) => (d ? new Date(d).toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit" }) : "—");
export const fdur = (min) => { const m = Math.max(0, Math.round(min || 0)); return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`; };
export const ago = (d) => {
  if (!d) return "";
  const s = (Date.now() - new Date(d).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 86400 * 7) return `${Math.floor(s / 86400)}d ago`;
  return new Date(d).toLocaleDateString("en-AU", { day: "numeric", month: "short" });
};
export const toLocalInput = (d) => {
  if (!d) return "";
  const x = new Date(d);
  const p = (n) => String(n).padStart(2, "0");
  return `${x.getFullYear()}-${p(x.getMonth() + 1)}-${p(x.getDate())}T${p(x.getHours())}:${p(x.getMinutes())}`;
};
export const fileUrl = (id, token) => `${API}/files/${id}/content${token ? `?t=${encodeURIComponent(token)}` : ""}`;
export const initials = (name = "") => name.split(" ").filter(Boolean).slice(0, 2).map((s) => s[0]?.toUpperCase()).join("") || "?";
export const label = (s = "") => String(s).replace(/_/g, " ");
export const mapsUrl = (addr) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(addr || "")}`;

export async function uploadFile(file, fields = {}, onProgress) {
  const form = new FormData();
  form.append("file", file);
  Object.entries(fields).forEach(([k, v]) => v !== undefined && v !== null && form.append(k, v));
  const { data } = await api.post("/files", form, { onUploadProgress: (e) => onProgress?.(Math.round((e.loaded / (e.total || 1)) * 100)) });
  return data;
}
